import React from "react";
import { Main } from "./style";
import PropTypes from "prop-types";

export default function Burger({ open, onClick }) {
    return (
        <>
            <Main open={open} onClick={onClick}>
                <div></div>
                <div></div>
                <div></div>
            </Main>
        </>
    );
}

Burger.propTypes = {
    open:PropTypes.bool,
    onClick:PropTypes.func
};
